import { normalizeRawCallingListRanking } from '../../lib'
import { CampaignCallingList } from '../../model/campaign'

export const mapCallingListFromRawData = (rawData: any): CampaignCallingList => ({
  id: rawData.Id,
  isr: rawData.ISR,
  partnerId: rawData.PartnerId,
  locationId: rawData.LocationId,
  campaignId: rawData.CampaignId,
  isVisible: rawData.IsVisible ?? true,
  ranking: normalizeRawCallingListRanking(rawData.Ranking),
})
